import React, { Component } from 'react';

// Components
import { PageSection } from '../PageSection';
import { SectionTitle } from '../generic/SectionTitle';
import { SlideshowScreens } from './AppSlideshow/SlideshowScreens';
import { DownArrow } from '../generic/DownArrow';

import { Carousel } from './AppSlideshow/Carousel';

export class AppSlideshow extends Component {
    constructor(props) {
        super(props);

        this.carouselLarge = React.createRef();
    }

    backImg() {
        this.carouselLarge.current.left();
    }

    forwardImg() {
        this.carouselLarge.current.right();
    }

    render() {
        return (
            <PageSection sectionId="app-slideshow">
                <DownArrow />
                <SectionTitle>Users can also choose from 10 designer-style spaces to add plants to.</SectionTitle>

                <div id="slideshow-frame-large" style={{ position: 'relative', width: '900px', height: '441px' }}>
                    <div id="slideshow-viewport-large" style={{ position: 'absolute', top: 'calc((441px - 388px) / 2)', left: 'calc((900px - 689px) / 2)', width: '689px', height: '388px', backgroundColor: '#a6cfda' }}>
                        <Carousel id="carousel-large" width={689} height={388} ref={this.carouselLarge} />
                    </div>

                    <div id="slideshow-frame-image-large" style={{ position: 'absolute', top: 0, left: 0 }}>
                        <img src="./images/generic/phone-body.png" alt="" />
                    </div>

                    <div className="back-control">
                        <img alt="" onClick={this.backImg.bind(this)} src="./images/generic/left-arrow.png" style={{ transform: 'translateY(-16px)' }} />
                    </div>
                    <div className="forward-control">
                        <img onClick={this.forwardImg.bind(this)} alt="" src="./images/generic/right-arrow.png" style={{ transform: 'translateY(-16px)' }} />
                    </div>
                </div>

                <SlideshowScreens />

                <DownArrow />
                {this.props.children}
            </PageSection>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/sections/AppSlideshow.jsx